import { render, staticRenderFns } from "./BaixaLote.vue?vue&type=template&id=4efa38d7&"
import script from "./BaixaLote.vue?vue&type=script&lang=js&"
export * from "./BaixaLote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports